//=require vendor/jquery.js
//=require vendor/jquery-migrate.js

// jQuery.noConflict();
jQuery.noConflict();

//=require vendor/stacktable.js
//=require vendor/mousewheel.js
//=require vendor/fancybox.js
//=require vendor/sidr.js

// dlrgjugendconfig.js
jQuery(document).ready(function() {
  jQuery("a.inline").fancybox({
    'transitionIn'  : 'fade',
    'transitionOut' : 'fade',
    'speedIn' : 500, 
    'speedOut'  : 500, 
    'overlayShow' : true,
    'hideOnContentClick': false,
                'autoDimensions'    : true
  }); 
  jQuery("area.inline").fancybox({
    'transitionIn'  : 'fade',
    'transitionOut' : 'fade',
    'speedIn' : 500, 
    'speedOut'  : 500, 
    'overlayShow' : false,
    'hideOnContentClick': false,
                'autoDimensions'    : true
  });
  jQuery("a.iframe").fancybox({
    'transitionIn'  : 'fade',
    'transitionOut' : 'fade',
    'speedIn' : 500, 
    'speedOut'  : 500, 
    'overlayShow' : true,
    'width'   : 950,
    'height'  : 500,
    'scrolling' : 'auto'
                
  });
  jQuery("a.images").fancybox({
    'transitionIn'  : 'fade',
    'transitionOut' : 'fade',
    'speedIn' : 500, 
    'speedOut'  : 500, 
    'overlayShow' : true,
                'showNavArrows' :       true,
                'titlePosition' : 'over',
                 'titleFormat' : function(title, currentArray, currentIndex, currentOpts) {
                    return '<span id="fancybox-title-over">Bild ' + (currentIndex + 1) + ' von ' + currentArray.length + ' ' + title + '</span>';
                }
  });
  jQuery("a.ajax").fancybox({
    ajax : {
      type : "POST",
      data : 'PING=1'
      }
  });
  
  //Set default open/close settings
  jQuery('.accordion_container').hide(); //Hide/close all containers
  jQuery('.accordion_trigger:first').not('.accordion_trigger2').addClass('opened').next().show(); //Add "active" class to first trigger, then show/open the immediate next container
    
    //On Click
  jQuery('.accordion_trigger').click(function(){
        if( jQuery(this).next().is(':hidden') ) { //If immediate next container is closed...
          jQuery(this).toggleClass('opened').next().slideDown(); //Add "active" state to clicked trigger and slide down the immediate next container
        } else if(!jQuery(this).next().is(':hidden') ) { //If immediate next container is closed...
          jQuery(this).toggleClass('opened').next().slideUp(); //Add "active" state to clicked trigger and slide down the immediate next container
        }
        return false; //Prevent the browser jump to the link anchor
    }); 

  jQuery('.klappbox').click(function(){
    jQuery(this).toggleClass('opened');
  });

  jQuery('.frame-jKlappbox').click(function(){
    jQuery(this).toggleClass('opened');
  });

  jQuery('#responsive-menu-button').sidr({
    name: 'sidr-main',
    source: '#navigation'
  }); 

  jQuery('table').not('.nonstackable').stacktable();

  jQuery('#content table').wrap( '<div class="table-wrapper"></div>' );

  jQuery('.csc-default > div > div > a[href*="dlrgnews"]').parent().addClass('news__mini-teaser');
  
  jQuery('#startseite #slider img[src="#"]').attr('src', '/global/layout/jugend/img/badelatschen-gross.jpg');
});


//=require vendor/nivo.js
